<a
    href="https://docs.apeer.com/create-modules/module-guidelines"
    target="_blank"
    rel="noopener"
    [ngClass]="{ 'badge rounded-pill bg-primary': presentationType === 'full' }"
    (click)="$event.stopPropagation()"
>
    <ca-icon
        *ngIf="presentationType === 'icon' || presentationType === 'icon-small'"
        name="compliant"
        [size]="presentationType === 'icon-small' ? 's' : 'l'"
        class="ca-color-compliant-blue"
        [removeSVGAttributes]="['stroke']"
        [ngbTooltip]="'GENERAL.FILTERS.COMPLIANT_TOOLTIP' | translate"
        placement="top"
        container="body"
    ></ca-icon>
    <div
        *ngIf="presentationType === 'full'"
        [ngbTooltip]="'GENERAL.FILTERS.COMPLIANT_TOOLTIP' | translate"
        placement="top"
        container="body"
        class="d-flex align-items-center compliant"
    >
        <ca-icon name="compliant" size="s" class="ca-color-compliant me-1" [removeSVGAttributes]="['stroke']"></ca-icon>
        {{ 'MODULES.COMPLIANCE.COMPLIANT' | translate }}
    </div>
</a>
